module.exports = __webpack_public_path__ + "img/heng.0ae349e1.png";